// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3lr0l","signatureButtonsRight":"ModalSign_signatureButtonsRight__nRNaJ"};